export default "__VITE_ASSET__BVODF86M__"